// extracted by mini-css-extract-plugin
module.exports = {"alert":"CancelHoldRequest_alert__2N6Wg"};